import styled from "@emotion/styled";
import BtnSimple from "../../components/buttons/BtbSimple";
import ShareIcon from "@icons-rf/shared-icon.svg?react";
import { FC, useEffect } from "react";
import { useRefererProperties } from "./RefererProperties.context";
import { useLoggedUser } from "@/shared/store/auth";
import { I_RealestateCard } from "../../model/interface/realestate-card.interface";
import ENVIRONMENT_VAR from "../../model/const/env/env.const";

interface IRealestateShareMultipleProps {
  count?: number;
}

const RealestateShareMultiple: FC<IRealestateShareMultipleProps> = props => {
  const { values } = useRefererProperties();
  const { userLogged } = useLoggedUser();

  const generateUrls = (data: I_RealestateCard[]) => {
    return data?.map(item => ({
      url: `${
        ENVIRONMENT_VAR.REMAX_DOMAIN
      }/propiedad/${item?.type_property?.replaceAll(" ", "-")}/${item.id}?referer=${
        userLogged?.userData?.people_id
      }`,
      title: `${item?.type_property?.replaceAll(" ", "-")} en ${
        item?.dirtyData?.business_type
      } en ${item?.dirtyData?.sector}`,
      suject: `${item?.type_property?.replaceAll(" ", "-")} en ${
        item?.dirtyData?.business_type
      } en ${item?.dirtyData?.sector}`,
      body: `${item?.type_property?.replaceAll(" ", "-")} en ${
        item?.dirtyData?.business_type
      } en ${item?.dirtyData?.sector} \n `
    }));
  };

  const onShare = () => {
    const urls = generateUrls(values).map(item => {
      return `${item.title}: ${item.url}`;
    });
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      urls.toString().replace(/,/g, "\n")
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {}, []);

  return (
    <Container>
      <BtnSimple variant-custom="green" startIcon={<ShareIcon />} onClick={onShare}>
        Compartir por WhatsApp
      </BtnSimple>
    </Container>
  );
};

export default RealestateShareMultiple;

const Container = styled.div`
  .MuiButton-root {
    background-color: #8cc63f;
  }
`;
